import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import graphql from 'services/querys';
import { NewBasicInfoType } from 'types/new-user';
import { z } from 'zod';
import validations from 'utils/validations';

export type fomrInfoTempType = NewBasicInfoType & {
  tabSelected: string;
};

export const useCreateContact = (onSuccess?: ({ _id, name }) => void, selctedKind?: string) => {
  const { t } = useTranslation();
  const schema = z.object({
    tabSelected: z.string().min(1),
    kind: z.string().optional(),
    first_name: validations.requiredString(t('validations:required')),
    last_name: z.string().optional(),
  }).passthrough().superRefine((data, ctx) => {
    if (data.tabSelected === 'Organization' && !data.kind) {
      ctx.addIssue({ path: ['kind'], code: z.ZodIssueCode.custom, message: t('validations:required') });
    }
    if (data.kind === 'Person' && !data.last_name) {
      ctx.addIssue({ path: ['last_name'], code: z.ZodIssueCode.custom, message: t('validations:required') });
    }
  });

  const methods = useForm<fomrInfoTempType>({
    defaultValues: {
      kind: selctedKind === 'Person' ? selctedKind : undefined,
      tabSelected: selctedKind,
    },
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const [created, setCreated] = useState(false);

  const { mutate: createParty, ...responseCreateParty } = useMutation(graphql.createParty, {
    onSuccess: (data) => {
      responseCreateParty.reset();
      setCreated(true);
      if (onSuccess) {
        onSuccess({ ...data.createParty });
      }
    },
    onError: () => {
      responseCreateParty.reset();
    },
  });

  return {
    methods,
    createParty,
    created,
    responseCreateParty,
  };
};
